import React from "react";
import "./Benner.css";
// import Vactor from "./IMG/Benner.png";
import Vactor from "./IMG/Newban.png";
import Bottom from "./IMG/Bottom.png";
import { Icon } from "@iconify/react";
import directionRotaryStraight from "@iconify/icons-carbon/direction-rotary-straight";

function Benner() {
  return (
    <>
      <div className="VaCa091">
        <div>
          <h1 className="Gaj018">
            Recruitment &amp; HR Support <br />
            Built Around Clear Requirements.
          </h1>
          <div className="Bahk0p1">
            <img className="Viamag" src={Vactor} alt="" />
          </div>
          <p className="Vahk011ZZZ">
            Quarec Resources supports employers and jobseekers with recruitment,
            staffing and practical hiring guidance. The scope and outcomes depend
            on each engagement and the decisions made by employers and candidates.
          </p>
          <div className="Vaop2">
            <Icon icon={directionRotaryStraight} rotate={2} />
          </div>
        </div>
        <div className="Bhaakjg">
          <img className="Vajhwo" src={Bottom} alt="" />
        </div>
      </div>
      <div className="Balq019">
        <h2 className="Valuj016ZZ">A clearer hiring process starts with the right brief</h2>
        <p className="Vakjfd132">
          Employers can clarify duties, essential skills, location, employment
          terms and the hiring timeline before a search begins. Candidates can
          review the role, prepare an accurate CV and confirm written offer
          details before making a decision.
        </p>
      </div>
    </>
  );
}

export default Benner;
